import { graphql, useStaticQuery } from 'gatsby';

const usePodcastLatestMasteringSTEpisode = () => {
  const { allContentfulPodcast } = useStaticQuery(graphql`
    {
      allContentfulPodcast(
        sort: { episode: DESC }
        limit: 1
        filter: { series: { eq: "Mastering ServiceTitan" }, episode: { ne: null } }
      ) {
        edges {
          node {
            ...Podcast
          }
        }
      }
    }
  `);

  return allContentfulPodcast?.edges?.[0]?.node;
};

export default usePodcastLatestMasteringSTEpisode;
